export const translations = {
  sv: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Hit eller dit?',
    sizeheading: 'Hur mycket väger det?',
    resultlistheading: 'Några utvalda val',
    weightlabel: 'Vikt',
    maxweightlabel: 'Maxvikt',
    maxmeasurementlabel: 'Maxvolym',
    senddirectcta: 'Köp frakt via Skicka Direkt',
    stampshopcta: 'Köp frimärken via vår webshop',
  },
  en: {
    componentheading: 'What do you want to send?',
    deliveryscopeheading: 'Here or there?',
    sizeheading: 'How much does it weigh?',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Weight',
    maxweightlabel: 'Max weight',
    maxmeasurementlabel: 'Maximum measurement',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  da: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Here or there?',
    sizeheading: 'How much does it weigh?',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vægt',
    maxweightlabel: 'Max vægt',
    maxmeasurementlabel: 'Maks. Volumen',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  no: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Here or there?',
    sizeheading: 'How much does it weigh?',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vekt',
    maxweightlabel: 'Maks vekt',
    maxmeasurementlabel: 'Maks volum',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  fi: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Here or there?',
    sizeheading: 'How much does it weigh?',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Paino',
    maxweightlabel: 'Max paino',
    maxmeasurementlabel: 'Max äänenvoimakkuus',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
};

export const markets = {
  se: {
    currency: 'kr',
  },
  dk: {
    currency: 'dk',
  },
  fi: {
    currency: ' €',
  },
  no: {
    currency: 'kr',
  },
};
